import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CustomButton from "../Common/CustomButton";

export default function DeleteConfirmationModal({
  open,
  onClose,
  onDelete,
  title,
  description,
}: {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  title: string;
  description: string;
}) {
  const [isDeleteting, setIsDeleting] = useState<boolean>(false);
  return (
    <Dialog open={open} sx={{ borderRadius: "4px" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: 2 }}>
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <DialogContent>
        <Alert severity="error">{description}</Alert>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ padding: 2 }}>
        <CustomButton variant="text" onClick={onClose}>
          Cancel
        </CustomButton>
        <CustomButton
          color="error"
          disabled={isDeleteting}
          variant="contained"
          onClick={async () => {
            setIsDeleting(true);
            try {
              await onDelete();
            } catch (error) {
              console.error("Error deleting:", error);
            } finally {
              setIsDeleting(false);
              onClose(); // Close the modal after deletion
            }
          }}
          startIcon={isDeleteting ? <CircularProgress size={24} /> : null}
        >
          Delete
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
}
